(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6509],{

/***/ 37395:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member/records",
      function () {
        return __webpack_require__(86157);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 66327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75302);

var useIsSmallScreen = function() {
    var breakpoint = antd__WEBPACK_IMPORTED_MODULE_0__/* ["default"].useBreakpoint */ .ZP.useBreakpoint();
    return {
        isSmallScreen: !breakpoint.md,
        breakpoint: breakpoint
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsSmallScreen);


/***/ }),

/***/ 84017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BE": function() { return /* binding */ Score; },
/* harmony export */   "Cg": function() { return /* binding */ Tutorial; },
/* harmony export */   "Ch": function() { return /* binding */ Tip; },
/* harmony export */   "Ct": function() { return /* binding */ Badge; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "EZ": function() { return /* binding */ BadgeName; },
/* harmony export */   "Ex": function() { return /* binding */ Progress; },
/* harmony export */   "Gk": function() { return /* binding */ BadgesContainer; },
/* harmony export */   "VG": function() { return /* binding */ Name; },
/* harmony export */   "Vh": function() { return /* binding */ BadgeIcon; },
/* harmony export */   "XF": function() { return /* binding */ Count; },
/* harmony export */   "aC": function() { return /* binding */ Level; },
/* harmony export */   "q": function() { return /* binding */ LevelContainer; },
/* harmony export */   "rU": function() { return /* binding */ Link; },
/* harmony export */   "u": function() { return /* binding */ Tooltip; },
/* harmony export */   "wS": function() { return /* binding */ ExpLabel; },
/* harmony export */   "yw": function() { return /* binding */ Rank; }
/* harmony export */ });
/* unused harmony exports Subscript, Container, Main */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);
/* harmony import */ var _tidb_community_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52873);
/* harmony import */ var _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22745);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21679);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36084);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58008);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding-bottom: 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border-radius: 6px;\n  width: 100%;\n  padding: 1rem;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 18px;\n  margin-right: 4px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 18px;\n  font-weight: bold;\n  margin-left: 0.5rem;\n  color: #e30c34;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: bold;\n  font-size: 30px;\n  color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  // gradient from left to right, orange to red\n  border: 1px solid ",
        ";\n  padding: 4px 8px;\n  margin-right: 4px;\n  border-radius: 1rem;\n  font-size: 12px;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: 4px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: #be1d32;\n  transform: translateY(-4px);\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  color: ",
        ";\n  margin-top: 1rem;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding-top: 2rem;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  text-decoration: none;\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  // two columns with equal width; first is icon, second is name\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  padding: 1rem;\n  border-radius: 6px;\n  background-color: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: 64px;\n  height: 64px;\n  object-fit: contain;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: center;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-align: left;\n  font-size: 14px;\n  position: relative;\n  padding-left: 1rem;\n\n  &:before {\n    position: absolute;\n    top: 3px;\n    left: 0;\n    content: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12.71' height='12.71' viewBox='0 0 12.71 12.71'%3E%3Cpath id='Icon_simple-gratipay' data-name='Icon simple-gratipay' d='M12.71,6.355A6.355,6.355,0,1,1,6.355,0,6.355,6.355,0,0,1,12.71,6.355ZM8.94,3.96a1.3,1.3,0,0,0-1.751.3A.973.973,0,0,1,6.4,4.6a.973.973,0,0,1-.79-.336,1.3,1.3,0,0,0-1.75-.3A1.316,1.316,0,0,0,3.51,5.8L6.4,9.718,9.291,5.8a1.318,1.318,0,0,0-.35-1.843Z' fill='%23f8c200'/%3E%3C/svg%3E%0A\");\n    margin-right: 4px;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  padding-left: 4px;\n  font-weight: 300;\n  color: #c7c7c7;\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  line-height: 1 !important;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}

// @ts-ignore

// @ts-ignore


var Title = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_2__/* .typography */ .cp("h3"));
var LevelContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject1(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.M1);
var Name = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject2(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.F2);
var Level = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject3());
var Score = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject4(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.B1);
var ExpLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject5(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.B1, _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.B1);
var Rank = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(Name)(_templateObject6());
var Subscript = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject7(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_2__/* .typography */ .cp("p2"));
var Tip = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject8(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_2__/* .typography */ .cp("p2"), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.F2);
var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject9(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_2__/* .responsive */ .jW());
var Link = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_components__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU)(_templateObject10(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.B1);
var Main = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject11());
var BadgesContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject12());
var Badge = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject13(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.M1, function(props) {
    return !props.owned && "filter: grayscale(100%)}; opacity: 50%;";
});
var BadgeIcon = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].img */ .ZP.img(_templateObject14());
var BadgeName = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject15());
var Tutorial = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZP.div(_templateObject16(), _tidb_community_ui__WEBPACK_IMPORTED_MODULE_3__.F1);
var Tooltip = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_templateObject17());
var Count = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].span */ .ZP.span(_templateObject18());
var Progress = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject19());


/***/ }),

/***/ 63683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Layout_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./src/pages/member/layout/layout.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #e9eaee;\n  padding-bottom: 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding-top: 2rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject());
var Container = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), mixins/* responsive */.jW());
var Main = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2());

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./node_modules/antd/es/menu/index.js + 8 modules
var menu = __webpack_require__(58928);
;// CONCATENATED MODULE: ./src/pages/member/layout/menu/menu.styled.js
function menu_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function menu_styled_templateObject() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  background: none;\n  border: none;\n\n  .ant-menu-item {\n    margin: 0 !important;\n  }\n"
    ]);
    menu_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function menu_styled_templateObject1() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  ",
        ";\n  list-style: none;\n  border: 1px solid ",
        ";\n"
    ]);
    menu_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function menu_styled_templateObject2() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n      cursor: default;\n      border-left: 4px solid ",
        ";\n      background: ",
        " !important;\n    "
    ]);
    menu_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = menu_styled_taggedTemplateLiteral([
        "\n  font-size: 1rem;\n  display: block;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n  cursor: pointer;\n  padding: 0 1rem;\n  transition: color 0.25s ease;\n  color: ",
        " !important;\n  &:not(:last-child) {\n    margin-bottom: 0.5rem;\n  }\n  &:hover {\n    color: ",
        " !important;\n  }\n  height: 40px;\n  line-height: 40px;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var MobileMenu = (0,styled_components_browser_esm/* default */.ZP)(menu/* default */.Z)(menu_styled_templateObject());
var menu_styled_Container = styled_components_browser_esm/* default.ul */.ZP.ul(menu_styled_templateObject1(), mixins/* reset */.mc(), mixins/* typography */.cp("p2"), colors.T2);
var Item = styled_components_browser_esm/* default.li */.ZP.li(_templateObject3(), colors.F1, colors.B1, function(props) {
    return props.isActive && (0,styled_components_browser_esm/* css */.iv)(menu_styled_templateObject2(), colors.B1, colors.M1);
});

;// CONCATENATED MODULE: ./src/pages/member/layout/menu/Menu.component.js




var Menu = function(param) {
    var isMobile = param.isMobile;
    var router = (0,next_router.useRouter)();
    var asPath = router.asPath;
    var pathPrefix = "/member";
    var routes = {
        "": "\u4F1A\u5458\u4E2D\u5FC3",
        "/redeem": "\u79EF\u5206\u5151\u6362",
        "/records": "\u79EF\u5206\u8BB0\u5F55",
        "/rules": "\u79EF\u5206\u89C4\u5219"
    };
    var handleMobileClick = function(e) {
        var key = e.key;
        router.push(key);
    };
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu, {
            mode: "horizontal",
            selectedKeys: [
                asPath
            ],
            onClick: handleMobileClick,
            children: Object.keys(routes).map(function(path) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenu.Item, {
                    children: routes[path]
                }, pathPrefix + path);
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_styled_Container, {
        children: Object.keys(routes).map(function(path) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item, {
                isActive: pathPrefix + path === asPath || path !== "" && pathPrefix + path + "/records" === asPath,
                onClick: function(e) {
                    e.preventDefault();
                    router.push(pathPrefix + path);
                },
                children: routes[path]
            });
        })
    });
};
/* harmony default export */ var Menu_component = (Menu);

;// CONCATENATED MODULE: ./src/pages/member/layout/menu/index.js


// EXTERNAL MODULE: ./src/context/index.js + 3 modules
var context = __webpack_require__(62675);
// EXTERNAL MODULE: ./src/layouts/index.js + 13 modules
var layouts = __webpack_require__(59269);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/hooks/useIsSmallScreen.js
var useIsSmallScreen = __webpack_require__(66327);
;// CONCATENATED MODULE: ./src/pages/member/layout/Layout.component.js









var Layout = function(param) {
    var children = param.children;
    var ref = (0,react.useContext)(context/* AuthContext */.Vo), setIsAuthRequired = ref.setIsAuthRequired, isAnonymous = ref.isAnonymous, login = ref.login;
    (0,react.useEffect)(function() {
        setIsAuthRequired(true);
        return function() {
            return setIsAuthRequired(false);
        };
    }, [
        setIsAuthRequired
    ]);
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    if (isAnonymous) {
        login();
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
            MainWrapper: Wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                    title: "\u4F1A\u5458\u4E2D\u5FC3",
                    description: "\u6B22\u8FCE\u6765\u5230\u4F1A\u5458\u4E2D\u5FC3\uFF01\u6765\u8FD9\u91CC\u67E5\u770B\u5347\u7EA7\u5C0F\u653B\u7565\uFF0C\u83B7\u53D6\u66F4\u591A\u79EF\u5206\u548C\u7ECF\u9A8C\uFF0C\u89E3\u9501\u66F4\u9AD8\u7EA7\u7684\u8363\u8A89\u6210\u5C31\uFF01"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        gutter: [
                            32,
                            32
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                sm: 8,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu_component, {
                                    isMobile: isSmallScreen
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                xs: 24,
                                sm: 16,
                                md: 18,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Main, {
                                    children: children
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Layout_component = (Layout);

;// CONCATENATED MODULE: ./src/pages/member/layout/index.js



/***/ }),

/***/ 86157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/pages/member/layout/index.js + 5 modules
var layout = __webpack_require__(63683);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./packages/datasource/src/api/points/index.js
var points = __webpack_require__(74685);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./node_modules/antd/es/table/index.js + 56 modules
var table = __webpack_require__(92714);
;// CONCATENATED MODULE: ./src/pages/member/records/index.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  background-color: ",
        ";\n  padding: 1rem;\n  border-radius: 6px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin-right: 0.5rem;\n  font-size: 18px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 18px;\n  margin-right: 2rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n  padding: 1rem;\n  border-radius: 6px;\n  background-color: ",
        ";\n\n  .ant-table-cell {\n    padding-left: 0;\n  }\n\n  thead[class*='ant-table-thead'] th {\n    background-color: ",
        " !important;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

// @ts-ignore


var PointsContainer = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), colors.M1);
var PointsContainerLabel = styled_components_browser_esm/* default.span */.ZP.span(_templateObject1(), colors.F1);
var PointsContainerValue = styled_components_browser_esm/* default.span */.ZP.span(_templateObject2(), colors.B1);
var Table = (0,styled_components_browser_esm/* default */.ZP)(table/* default */.Z)(_templateObject3(), colors.M1, colors.M1);

// EXTERNAL MODULE: ./src/pages/member/index.styled.ts
var index_styled = __webpack_require__(84017);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/index.js + 1 modules
var config_provider = __webpack_require__(19040);
// EXTERNAL MODULE: ./node_modules/antd/es/empty/index.js + 2 modules
var empty = __webpack_require__(62986);
// EXTERNAL MODULE: ./src/utils/index.js + 3 modules
var utils = __webpack_require__(59874);
;// CONCATENATED MODULE: ./src/pages/member/records/index.page.tsx


// @ts-ignore




// @ts-ignore





var Page = function() {
    var isReady = (0,router.useRouter)().isReady;
    var data1 = (0,dist/* default */.ZP)(isReady && [
        "points.getMe"
    ]).data;
    var ref = (0,react.useState)(1), currentPage = ref[0], setCurrentPage = ref[1];
    var ref1 = (0,react.useState)(20), perPage = ref1[0], setPerPage = ref1[1];
    var ref2 = (0,react.useState)(0), total = ref2[0], setTotal = ref2[1];
    // const { data: records } = useSWR<api.ApiResponse<{ data: api.points.AwardedPointEntry[] }, any>, any>(isReady && ['points.getAwardedPoints', {currentPage, perPage}]);
    // when currentPage changes, fetch new data
    var ref3 = (0,react.useState)([]), tableData = ref3[0], setTableData = ref3[1];
    (0,react.useEffect)(function() {
        points.getAwardedPoints({
            currentPage: currentPage,
            perPage: perPage
        }).then(function(data) {
            setTableData(data.data);
            setTotal(data.total_num);
        });
    }, [
        isReady,
        currentPage,
        perPage
    ]);
    if (!data1 || !tableData) return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* PageLoader */.wY, {})
    });
    var pointsData = data1 === null || data1 === void 0 ? void 0 : data1.data;
    var columns = [
        {
            title: "\u6458\u8981",
            dataIndex: "digest"
        },
        {
            title: "\u79EF\u5206\u53D8\u5316",
            dataIndex: "points"
        },
        {
            title: "\u7ECF\u9A8C\u503C\u53D8\u5316",
            dataIndex: "exps"
        },
        {
            title: "\u5907\u6CE8",
            dataIndex: "comment"
        },
        {
            title: "\u65F6\u95F4",
            dataIndex: "created_at"
        }, 
    ];
    var onChange = function(page, pageSize) {
        setCurrentPage(page);
        setPerPage(pageSize);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PointsContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PointsContainerLabel, {
                                        children: "\u7ECF\u9A8C\u503C"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PointsContainerValue, {
                                        children: pointsData.current_exps
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PointsContainerLabel, {
                                        children: "\u79EF\u5206"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PointsContainerValue, {
                                        children: pointsData.current_points
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled/* Tutorial */.Cg, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_styled/* Link */.rU, {
                                href: "/member/rules",
                                children: "\u5347\u7EA7\u653B\u7565"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(config_provider/* default */.ZP, {
                renderEmpty: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* default */.Z, {
                        image: utils/* cdn.getImageUrl */.cK.getImageUrl("/images/list-placeholder.svg"),
                        description: "\u6682\u65E0\u6570\u636E"
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
                    columns: columns,
                    dataSource: tableData,
                    pagination: {
                        position: [
                            "bottomCenter"
                        ],
                        onChange: onChange,
                        total: total,
                        pageSize: perPage
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var index_page = (Page);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [469,8422,2610,9774,2888,179], function() { return __webpack_exec__(37395); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);